// The in-game system menu (Esc on any document screen, or the shell's gear): resume, settings,
// back to the World (not on the guided path, ui/guided.ts), leave the World, the title screen, sign out.
import { Button, MenuItem, MenuList, Modal, confirmDialog } from '../components';
import { useRoute } from '../../core/stores/route';
import { useSession } from '../../core/stores/session';
import { useOverlay } from '../overlay';
import { useGuided } from '../guided';
import { useParty, useWorld, useWorldClock } from '../../core/subscriptions/hooks';
import { useEncounter } from '../../core/encounter/session';
import { identityHex } from '../../core/net/connection';
import { rpc } from '../../core/net/reducers';
import { shortDate } from '../../core/story/calendar';
import { worldTitle } from '../../core/story/worldName';

export function SystemMenu() {
  const open = useOverlay((s) => s.menu);
  const close = useOverlay((s) => s.closeMenu);
  const openSettings = useOverlay((s) => s.openSettings);
  const go = useRoute((s) => s.go);
  const screen = useRoute((s) => s.screen);
  const guided = useGuided();
  const worldId = useSession((s) => s.worldId);
  const setWorld = useSession((s) => s.setWorld);
  const signOut = useSession((s) => s.signOut);
  const world = useWorld(worldId);
  const clock = useWorldClock(worldId);
  const leave = async () => {
    close();
    if (await confirmDialog({ title: `Leave ${world ? worldTitle(world) : 'this World'}?`, text: 'Your heroes stay where they are; you can enter again from the World list.', confirmLabel: 'Leave' })) { setWorld(undefined); go('world', { partyId: undefined, encounterId: undefined, instanceId: undefined }); }
  };
  // docs/83: the party's lead can abandon the room from here (it was a button under the plan list)
  const encounterId = useEncounter((s) => s.encounterId);
  const party = useParty(useEncounter((s) => s.partyId));
  const me = useSession((s) => s.identity);
  const canAbandon = screen === 'encounter' && encounterId !== undefined && !!party && identityHex(party.lead) === me;
  const abandon = async () => {
    close();
    if (encounterId !== undefined && await confirmDialog({ eyebrow: 'Leave the fight', title: 'Abandon the encounter?', text: 'The party withdraws from this room; the fight counts as fled.', confirmLabel: 'Abandon', danger: true })) void rpc.abandonEncounter(encounterId);
  };
  const out = async () => { close(); if (await confirmDialog({ title: 'Sign out?', text: 'The anonymous token is dropped; a new identity is issued next time.', confirmLabel: 'Sign out', danger: true })) signOut(); };
  return (
    <Modal open={open} onClose={close} eyebrow={world ? (clock ? `${worldTitle(world)} · ${shortDate(clock)}` : worldTitle(world)) : 'Fellowkeep'} title="Menu" size="narrow" testId="system-menu" footer={<Button variant="ghost" onClick={close}>Resume <kbd className="fk-kbd">Esc</kbd></Button>}>
      <MenuList label="System menu">
        <MenuItem index={0} primary onClick={close} data-testid="menu-resume" data-autofocus>Resume</MenuItem>
        <MenuItem index={1} onClick={openSettings} data-testid="menu-settings" hint="⚙">Settings</MenuItem>
        {canAbandon && <MenuItem index={2} onClick={() => void abandon()} data-testid="abandon" hint="⚑">Abandon room</MenuItem>}
        {worldId && screen !== 'world' && !guided && <MenuItem index={2} onClick={() => { close(); go('world'); }} data-testid="menu-world">World screen</MenuItem>}
        {worldId && <MenuItem index={3} onClick={() => void leave()} data-testid="menu-leave-world">Leave World</MenuItem>}
        <MenuItem index={4} onClick={() => { close(); go('title'); }} data-testid="menu-title">Title screen</MenuItem>
        <MenuItem index={5} onClick={() => void out()} data-testid="menu-sign-out">Sign out</MenuItem>
      </MenuList>
    </Modal>
  );
}
